// src/functions/validators/isValidEmail.js
export function isValidEmail(str = "") {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(str).trim());
  }
  